<template>
  <div class="app-container">
    <list ref="list">
        
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/statistics/returngoods/list'

export default {
  name: "returngoods",
  mixins: [curdMixins],
  components: { list },
  methods: {
    
  }
};
</script>